<template>
	<div style="width:90%">
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="orderInfo" style="margin: 20px 0px 0px 20px;">
					<el-form-item label="岗位名称" class='tiny'>
						<el-input style="width:300px;" v-model="orderInfo.jobTitle" placeholder="请输入岗位名称">
						</el-input>
					</el-form-item>
					<el-form-item label="店铺名称" v-if="stoId==0" class='tiny'>
						<el-input style="width:300px;" v-model="orderInfo.storeName" placeholder="请输入店铺名称">
						</el-input>
					</el-form-item>
					<el-form-item label="状态" class='tiny'>
						<el-select v-model="orderInfo.status">
							<el-option key="-1" label="全部" value="">全部</el-option>

							<el-option value="true" label="启用">启用</el-option>
							<el-option value="false" label="停用">停用</el-option>
						</el-select>
					</el-form-item>
					
					<el-form-item>
						<template>
							<el-button type="primary" @click="search">查询</el-button>
							<el-button type="primary" @click="empty">清空</el-button>
						</template>
					</el-form-item>
					<el-button v-if="stoId!=0" type="primary" @click="editialogVisible()">新增</el-button>
				</el-form>

			</header>

		</div>
		<!-- 列表展示 -->
		<el-table :data="expressList" stripe style="width: 100%">
			<el-table-column type="index" align="center" width="90" label="#">
			</el-table-column>
			<el-table-column prop="storeName" v-if="stoId==0" label="店铺名称" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="jobTitle" label="岗位名称" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="levelName" label="级别名称" align="center" width="" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					{{scope.row.levelName?scope.row.levelName:'无级别'}}
				
				</template>
			</el-table-column>
			<el-table-column prop="cardName" label="卡项名称" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="rewardRate" label="核销收益比例" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="rewardNum" label="核销收益金额" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="status" label="状态" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<span v-if="scope.row.status==true">启用</span>
					<span v-if="scope.row.status==false">停用</span>
				</template>
			</el-table-column>
			<el-table-column prop="createBy" label="操作人" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<!-- <el-table-column prop="isLevel" label="是否开启级别" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<span v-if="scope.row.isLevel==true">是</span>
					<span v-if="scope.row.isLevel==false">否</span>
				</template>
			</el-table-column> -->
			<el-table-column prop="createDate" label="创建时间" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="updateDate" label="更新时间" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop=""  label="操作"  fixed="right" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<el-button size="small" type="text" @click="editialogVisible(scope.row.id)">编辑</el-button>
					<el-button size="small" type="text" @click="toDelete(scope.row.id)">删除</el-button>
					<el-button  size="small" v-if="!scope.row.status" type="text" @click="glstatus(scope.row.id,1)">启用</el-button>　
					<el-button style="color: red;" size="small" v-else type="text" @click="glstatus(scope.row.id,2)">停用</el-button>　　　
				</template>
			</el-table-column>
		</el-table>
		<!-- 分页 -->
		<el-pagination style="margin: 20px" background :current-page="sliderlist.pageNum"
			@current-change="pageChange" layout="total, sizes, prev, pager, next, jumper" :total="sliderlist.total"
			@size-change="handleSizeChange">
		</el-pagination>
		<!-- 新增 -->
		<el-dialog :visible.sync="dialogVisibleSwiper" :title="title" @close="addDialogClose"
			:close-on-click-modal="false">
			<div style="text-align: center">
				<el-form v-model="storeGoodsInfo">
					
					<el-form-item label="店铺名称" v-if="title=='编辑岗位'">
						<el-input disabled type="text" style="width: 200px;;" v-model="storeGoodsInfo.storeName"
							auto-complete="off" placeholder="请输入店铺名称" />
					</el-form-item>
					<el-form-item label="岗位名称">
						<el-select v-model="storeGoodsInfo.jobId" @change="change" style="width: 200px;">
									
							<el-option v-for="item in gwList" :key="item.id" :value="item.id" :label="item.name">{{item.name}}</el-option>
								
							</el-select>
					</el-form-item>
					<el-form-item label="选择级别"  v-if="sInfo.isLevel">
						<el-select v-model="storeGoodsInfo.jobLevelId" style="width: 200px;">
								
						<el-option v-for="item in jbList" :key="item.id" :value="item.id" :label="item.name">{{item.name}}</el-option>
							
						</el-select>
					
					</el-form-item>
					<el-form-item label="选择卡项">
						<el-select v-model="storeGoodsInfo.cardId" style="width: 200px;">
								
						<el-option v-for="item in KxList" :key="item.id" :value="item.id" :label="item.cardName">{{item.cardName}}</el-option>
							
						</el-select>
					
					</el-form-item>
					
					<el-form-item label="收益比例" class="redItem">
						<el-input style="width: 200px;margin-right: 10px;" type="number" v-model="storeGoodsInfo.rewardRate" placeholder="请输入比例">
											
						</el-input>
						例如（0.88）
					</el-form-item>
					<el-form-item label="收益金额" class="redItem" >
						<el-input style="width: 200px;margin-right: 10px;" type="number" v-model="storeGoodsInfo.rewardNum" placeholder="请输入金额">
											
						</el-input>
						非必填
					</el-form-item>
					
				
					<el-button type="primary" v-if="title=='新增岗位'" @click="sure" style="margin-top: 100px;"
					:loading="sureLoading">提交</el-button>
					<el-button type="primary" v-else @click="submit" style="margin-top: 100px;"
					:loading="submitLoading">编辑</el-button>
					
				</el-form>
			</div>
		</el-dialog>
		<!-- 编辑修改 -->
		
	</div>
</template>

<script>
	import {
		quillEditor
	} from "vue-quill-editor"; //调用编辑器
	import "quill/dist/quill.core.css";
	import "quill/dist/quill.snow.css";
	import "quill/dist/quill.bubble.css";
	import {
		uploadFileServer
	} from "@/api/axios.js";
	var urls = uploadFileServer('job');
	export default {
		components: {
			//使用编辑器
			quillEditor
		},
		data() {
			return {
				jbList:[],
				stoId:'',
				sInfo:{},
				page: {
					pageNum: 1,
					pageSize: 10,
				},
				tableData:[
					{
						levelName:'',
						orderIndex:'',
						status:false
					}
				],
				
				sliderlist:{},
				expressList: [],
				orderInfo: {
					status: '',
				},
				storeGoodsInfo: {
					isLevel:false
				},
				dialogVisibleSwiper: false,
				dialogVisibleSwipers: false,
				title:'',
				KxList:[],
				gwList:[],
				dialogImageUrl:'',
				httpUrl: urls,
				httpUrl1: urls,
				fileList: [],
				fileList1: [],
				goodsImages:[],
				editorOption: {
					// 富文本编辑器配置
					placeholder: "请输入内容",
					modules: {
						toolbar: {
							container: [
								["bold", "italic", "underline", "strike"], // 加粗，斜体，下划线，删除线
								[{
										header: 1,
									},
									{
										header: 2,
									},
								], // 标题，键值对的形式；1、2表示字体大小
								[{
										list: "ordered",
									},
									{
										list: "bullet",
									},
								], // 列表
								[{
										script: "sub",
									},
									{
										script: "super",
									},
								], // 上下标
								[{
										indent: "-1",
									},
									{
										indent: "+1",
									},
								], // 缩进
								[{
									direction: "rtl",
								}, ], // 文本方向
								[{
									size: ["small", false, "large", "huge"],
								}, ], // 字体大小
								[{
										color: [],
									},
									{
										background: [],
									},
								], // 字体颜色，字体背景颜色
								[{
									align: [],
								}, ], // 对齐方式
								["clean"], // 清除字体样式
								["image"], // 上传图片、上传视频
							],
							handlers: {
								image: function(value) {
									console.log(value)
									if (value) {
										document
											.querySelector("#lpc-quill .upload-demo input")
											.click();
									} else {
										this.quill.format("image", false);
									}
								},
							},
				
						},
					},
					theme: "snow",
				},

				sureLoading: false,
				submitLoading: false,
			}
		},
		methods: {
			sure(){
				this.sureLoading = true;
				this.$api.adderpCardJobReward({...this.storeGoodsInfo}).then(res=>{
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.pmsbrdselect()
						this.dialogVisibleSwiper = false
						this.storeGoodsInfo = {}
					} else {
						this.$message.error(res.message);
					}
					this.sureLoading = false;
				})
			},
			del(it){
				this.tableData.splice(it,1)
				
			},
			add(){
				this.tableData.push({
					levelName:'',
					orderIndex:'',
					status:false
				})
			},
			addDialogClose(){
				this.dialogVisibleSwiper=false
			},
		
			search() { //查询
					
				this.pmsbrdselect()

			},
			empty() { //清空
				this.orderInfo = {}
				this.page.pageNum=1
			},
			
			pmsbrdselect() {
				let data = {
					 pageNum: this.page.pageNum,
					 pageSize: this.page.pageSize,
					...this.orderInfo
				}
				this.$api.finderpCardJobReward(data).then((res) => {
					console.log(res)
					if (res.state == 'success') {
						this.expressList = res.data.list
						this.sliderlist = res.data
					}
				})

			},
			// 新增
		

			// 提交
			submit() {
				this.submitLoading = true;
				let data = this.storeGoodsInfo
				// console.log(data)
				this.$api.editerpCardJobReward(data).then((res) => {
					// console.log(res)
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.pmsbrdselect()
						this.dialogVisibleSwiper = false
						this.storeGoodsInfo = {}
					} else {
						this.$message.error(res.message);
					}
					this.submitLoading = false;
				})

			},
			change(e){
				
				this.sInfo=this.gwList.find(item=>item.id==e)
				console.log(this.sInfo);
				this.$api.erpJobLevel(e).then(res=>{
					this.jbList=res.data
					
				})
			},
			// 编辑
			editialogVisible(e) {
				this.dialogVisibleSwiper=true
				if(e){
					
					this.title='编辑岗位'
					this.$api.findByIderpCardJobReward(e).then((res) => {
						if (res.state == 'success') {
							console.log(res);
							this.storeGoodsInfo = res.data
							this.sInfo=this.gwList.find(item=>item.id==res.data.jobId)
							this.$api.erpJobLevel(res.data.jobId).then(res=>{
								this.jbList=res.data
								
							})
							this.dialogVisibleSwipers = true
					
						}
					})
				}else{
					this.title='新增岗位'
					this.storeGoodsInfo = {}
					this.tableData=[
						{
							levelName:'',
							orderIndex:'',
							status:false
						}
					]
				}
				
				
			
				
			},
			glstatus(e,type){
				if(type==2){
					var str = "此操作将停用该岗位分成, 是否继续?"
				}else{
					var str = "此操作将启用该岗位分成, 是否继续?"
				}
				
				this.$confirm(str, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					console.log(e)
					this.$api.statuserpCardJobReward(e).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.pmsbrdselect();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});
			},
			
			// 删除
			toDelete(e) {
				console.log(e)
				var str = "此操作将删除该岗位分成, 是否继续?"
				this.$confirm(str, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					console.log(e)
					this.$api.delerpCardJobReward(e).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.pmsbrdselect();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});

			},
			pageChange(data) {
				this.page.pageNum = data
				this.pmsbrdselect();
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.pmsbrdselect()
			},
		},




		created() {
			this.pmsbrdselect()
			this.$api.getUserInfo(this.$encrypt({})).then(res => {
				res.data = JSON.parse(this.$decrypt(res.data)).data
				if (res.state == 'success') {
					// console.log('登录人信息---', res.data )
					// supplierId(有值就是供应商)
					this.stoId = res.data.storeId; // storeId：0(平台)   
					
				}
			})
			this.$api.geterpJob().then(res=>{
				
				this.gwList=res.data
			})
			this.$api.finderpCard({}).then(res=>{
				console.log(res);
				this.KxList=res.data.list
			})
		}
	}
</script>

<style>

</style>
